// A few short explanations at the foot of a follow-up reading page.
//
// The pages after the goal sheet and the whiteboard are read by the client
// afterwards rather than presented, so they can explain themselves in a way a
// presented slide should not (Amanda Cook, 2026-10-02). Each item is general
// and true of any household, so nothing here is written per client.

export default function Explainer({ title, items = [] }) {
  if (!items.length) return null;
  return (
    <section className="conv-explain" aria-label={title}>
      <div className="conv-eyebrow">{title}</div>
      <div className="conv-explain-grid" data-count={items.length}>
        {items.map(i => (
          <div key={i.title}>
            <strong>{i.title}</strong>
            <p>{i.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
